import React from "react";

const TimeInput = (props) => {
    return (
        <input
            className="date-pickers form-input rounded-none w-full shadow-red py-3 text-lg"
            type="time"
            name={props.name}
            value={props.value}
            onChange={(event) => props.handleChange(event, props.identity)}
            placeholder={props.placeholder ? props.placeholder : null}
            onBlur={props.onBlur ? () => props.onBlur() : null}
        />
    );
};

export default TimeInput;
